export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'ADMIN': 'Admin',
            'ORGANISATIONS'        : {
                'TITLE': 'Organisations',
            },
            'USERS'        : {
                'TITLE': 'Users',
            },
            'MODULES'        : {
                'TITLE': 'Training Modules',
            }, 
            'PROGRESS'        : {
                'TITLE': 'User Progress',
            }
            
            
        }
    }
};



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/navigation/i18n/en.ts